import useSWR from "swr";
import { getEntities } from "../services/template-service";
import type { EntitiesResponse, EntityItem } from "../types/api-types";

export interface UseEntitiesReturn {
  entities: EntityItem[] | undefined;
  isLoading: boolean;
  // SWR returns any, so a more explicit type cannot be used
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
}

const useEntities = (): UseEntitiesReturn => {
  const { data, error, isLoading } = useSWR<EntitiesResponse>(
    "entity-types",
    getEntities,
  );

  return {
    entities: data?.results,
    isLoading,
    error,
  };
};

export default useEntities;
